module.exports = __webpack_public_path__ + "static/media/stopover-azores.3e0b0320.svg";